import { ReactNode } from 'react'
import styled from '@emotion/styled'

interface V2L2ModalContentProps {
	upper?: boolean
	columns?: boolean
}

export const V2L2ModalContent = styled.div<V2L2ModalContentProps>(({theme, upper, columns}) => ({
	backgroundColor: upper ? theme.colors.third : theme.colors.second,
	padding: '1rem',
	display: columns ? 'grid' : 'block',
	gridTemplateColumns: columns ? '1fr 1fr' : undefined,
	rowGap: columns ? '1rem' : undefined,
	overflowY: 'auto',
}))

export const V2L2ModalDetailRoot = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'stretch',
	rowGap: '0.25rem',
})

interface V2L1ModalDetailLabelProps {
	upper?: boolean
}

export const V2L1ModalDetailLabel = styled.div<V2L1ModalDetailLabelProps>(({theme, upper}) => ({
	fontSize: `${14/16}rem`,
	// fontWeight: 600,
	color: upper ? theme.colors.text : theme.colors.inputLabel,
}))

export const V2L1ModalDetailValue = styled.div({
	fontWeight: 600,
})

interface V2L2ModalDetailProps {
	upper?: boolean
	title: string
	children?: ReactNode
}

export const V2L2ModalDetail = ({upper, title, children}: V2L2ModalDetailProps) => {
	return (
		<V2L2ModalDetailRoot>
			<V2L1ModalDetailLabel upper={upper}>{title}</V2L1ModalDetailLabel>
			<V2L1ModalDetailValue>{children}</V2L1ModalDetailValue>
		</V2L2ModalDetailRoot>
	)
}
